<div class="info-box">
  <div #triggerEl class="info-icon" (click)="togglePopup($event)">
    <img src="/assets/u205.svg" alt="" />
  </div>
</div>

<ng-template #popupPanel>
  <div class="information-popup-sheet">
    <div class="popup-content">
      <span class="close" (click)="closePopup()">&times;</span>
      <div class="infocontent" [innerHTML]="information"></div>
    </div>
  </div>
</ng-template>
